import HighchartsReact from "highcharts-react-official";
import React, { useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge";
HighchartsMore(Highcharts);
solidGauge(Highcharts);
type Props = {
  chartOptions: any;
  onInit?: (
    ref: React.MutableRefObject<Highcharts.Chart | null | undefined>
  ) => void;
};

const HighChart = React.memo((props: Props) => {
  const { chartOptions, onInit } = props;
  const chartRef = React.useRef<Highcharts.Chart | null | undefined>(null);

  useEffect(() => {
    if (chartRef.current) {
      if (onInit) onInit(chartRef);
    }
  }, [chartRef.current]);
  return (
    <HighchartsReact
      ref={(ch) => {
        chartRef.current = ch?.chart;
      }}
      updateArgs={[true, true, true]}
      highcharts={Highcharts}
      options={chartOptions}
      oneToOne
    />
  );
});

export default HighChart;
